import type { ProspectHomepageSlide } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';
import type { Settings } from 'react-slick';

import { CMSHTML, CMSImage } from '@swf/cms';

import CardContentItem from '../../CardContentItem/CardContentItem';

import styles from './CardsSlider.scss';

interface Props {
  slide: ProspectHomepageSlide;
  clickHandler?: Settings['onSwipe'];
}

const CardsSliderItem: React.FC<Props> = ({
  slide: {
    image_with_text: { image, text },
    content
  },
  clickHandler
}) => (
  <div onClick={() => clickHandler?.('')} className={styles.card}>
    {image.asset && (
      <div className={styles.imageWrapper}>
        <CMSImage {...image} />
        <CMSHTML {...text} className={styles.imageText} />
      </div>
    )}
    <div className={classNames(styles.content, { [styles.topBorder]: !image.asset })}>
      {content.map((item, index) => (
        <CardContentItem key={index} item={item} />
      ))}
    </div>
  </div>
);

export default CardsSliderItem;
